import { Section } from '../../components/Section'
import { Form } from '../../components/Form'

export function Contato() {
 return (
  <Section id="contato" title="Contato" className="pt-20">
   <div className="container">
    <div className="w-full">
     <div className="map max-[768px]:h-[154px] min-[768px]:h-[208px] min-[992px]:h-[280px] min-[1200px]:h-[353px] relative top-5 group">
      <iframe
       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.355056822787!2d-46.68209522403091!3d-23.519728828828484!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cef90953061699%3A0x2b8382ce0d578be8!2sWeWork%20Sala%20Comercial%20%26%20Coworking!5e0!3m2!1spt-BR!2sbr!4v1744915323471!5m2!1spt-BR!2sbr"
       width="100%"
       className="max-[768px]:h-[154px] min-[768px]:h-[208px] min-[992px]:h-[280px] min-[1200px]:h-[353px] border-0 max-[768px]:opacity-100 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-opacity duration-300"
       allowFullScreen
       loading="lazy"
       referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
     </div>
    </div>
   </div>
   <div className="bg-[var(--primary-yellow)] max-[768px]:h-auto min-[768px]:h-[410px] min-[992px]:h-[380px]">
    <div className="container">
     <Form />
    </div>
   </div>
  </Section>
 )
}
